<template>
	<el-dialog :visible.sync="showimportwin" :title="dialogtitle" width="500px" :append-to-body="true"  :close-on-click-modal="false">
		<div class="divimport" style="text-align: center;">
			<el-upload
				name="fileupload"
				drag
				:action="fileurl"
				:multiple="false"
				:limit="1"
				accept="*"
				:auto-upload="false"
				:on-success="UploadSuccess"
				:on-error="UploadError"
				:on-change="UploadChange"
				:show-file-list="false"
				ref="upload"
				:file-list="filelist"
			>
				<i class="el-icon-upload"></i>
				<div class="el-upload__text">
					将文件拖到此处，或
					<em>点击上传</em>
					<br />
					( 支持 .zip .rar 文件 )
				</div>
			</el-upload>
			<div style="width:100%;text-align:center;">{{ filename }}</div>
			<!-- </el-card> -->
			<span slot="footer" class="dialog-footer">
				<div style="text-align:center;width:100%;padding-top:10px">
					<el-button size="mini" type="success" @click.native="sure">确定</el-button>
					<el-button size="mini" style="margin-left:10px" type="info" plain @click.native="showimportwin = false">关闭</el-button>
				</div>
			</span>
		</div>
	</el-dialog>
</template>

<script>
import Utils from '../../lib/util.js';
export default {
	components: {},
	props: {},
	data() {
		return {
			showimportwin: false,
			fileurl: '',
			dialogtitle: '',
			mode: '', //功能名称
			downpath: '',
			filename: '',
			divclass: 'divimport',
			uploadfileurl: '',
			filelist: [],
			isreload:false,
			cargotype:''
		};
	},
	methods: {
		init(param) {
			this.filelist = [];
			this.filename = '';
			this.uploadfileurl = '';
			this.showimportwin = true;
			this.mode = param.mode;
			this.dialogtitle = param.dialogtitle;
			if(param.cargotype!=undefined)
				this.cargotype=param.cargotype;
			this.fileurl =
				this.$apiprototype.ApiServer +
				'/Cargo/UploadCargoPic?domain=' +
				this.$apiprototype.WebServer+'&cargotype='+this.cargotype;
			//console.log('url',this.fileurl);
		},
		UploadSuccess(res, file, fileList) {
			//console.log('上传结果',res);
			this.$tool.loadingclose();
			if (res.state == '1') {
				this.$tool.message(res.message, 1);
				this.showimportwin = false;
			} else {
				this.$tool.message(res.message, 0);
			}
			if(res.localfilename!=undefined&&res.localfilename!=""){
				this.$tool.downfile(this, res.localfilename,'');
			}
			this.filename = '';
			this.filelist=[];
			this.$refs.upload.clearFiles();
		},
		UploadError(err, file, fileList) {
			console.log('上传错误 error', err);
		},
		UploadChange(file, fileList) {
			console.log('上传改变',file);
			this.filename=file.name;
			if(this.filelist.length==0)
				this.filelist.push(file);
		},
		sure(){
			if(this.filelist.length>0)
			{
				this.$tool.loading('正在上传',this.divclass);
				this.$refs.upload.submit();
			}
				
			else
				this.$tool.message('请选择文件', 0);
		}
	}
};
</script>
